import {Component, OnInit, ViewChild} from '@angular/core';
import { EnviarTokenFirmaElectronicaComponent } from './enviar-token-firma-electronica/enviar-token-firma-electronica.component';
import { TokenEnviadoComponent } from './token-enviado/token-enviado.component';
import { EscribaTokenEnviadoComponent } from './escriba-token-enviado/escriba-token-enviado.component';
import { TramiteFirmadoComponent } from './tramite-firmado/tramite-firmado.component';
import { Router } from '@angular/router';
import {
  ICrearPseUrlFacturacion,
  IDataSolicitud,
  IFacturaExternaTmp
} from "../../../shared/interfaces/liquidacion";
import {environment} from "../../../../environments/environment";
import {ConstantPortal} from "../../../shared/constants/constant-portal";
import {firstValueFrom, forkJoin, Observable} from "rxjs";
import {ReciboService} from "../../../services/recibo.service";
import { SessionStorageService, AlertIcon, AlertService, LoadingPanelService, ImpuestosFuente } from "lib-base";
import {FacturaExternaTmpService} from "../../../services/liquidacion/factura-externa-tmp.service";
 import {TranslateService} from "@ngx-translate/core";
import { FirmaElectronicaTokenService } from '../../../services/firmaElectronicaToken.service';
import { InfoDispositivo, RequestFirmarDeclaracion, TramiteFirmadoId } from '../../../shared/interfaces/firma_electronica';
import { TramiteFirmasElectronicasService } from '../../../services/tramiteFirmasElectronicas.service';

@Component({
  selector: 'app-procesar-tramite',
  standalone: true,
  imports: [EnviarTokenFirmaElectronicaComponent, TokenEnviadoComponent, EscribaTokenEnviadoComponent, TramiteFirmadoComponent],
  templateUrl: './procesar-tramite.component.html',
  styleUrl: './procesar-tramite.component.scss'
})
export class ProcesarTramiteComponent implements OnInit  {
  private _requierePago: boolean = false;
  private _tieneFuentePago: string = '';
  #tramRegistroSolicitudId !: number;
  #ipAddress !: string;
  escribaTokenEnviadoBtnSubmitLabel: string = "";

  lote:number | undefined = undefined;

  private translations:any = {};

  get fuentePago(): string {
    return this._tieneFuentePago;
  }

  set fuentePago(value: string) {
    this._tieneFuentePago = value;
  }

  get requierePago(): boolean {
    return this._requierePago;
  }

  set requierePago(value: boolean) {
    this._requierePago = value;
  }

  @ViewChild(EnviarTokenFirmaElectronicaComponent) private  _enviarTokenFirmaElectronica !: EnviarTokenFirmaElectronicaComponent;
  @ViewChild(TokenEnviadoComponent) private _tokenEnviado !: TokenEnviadoComponent;
  @ViewChild(EscribaTokenEnviadoComponent) private _escribaTokenEnviado !: EscribaTokenEnviadoComponent;
  @ViewChild(TramiteFirmadoComponent) tramiteFirmado !: TramiteFirmadoComponent;

  constructor(private router: Router, private _sitiGobService: ReciboService,
              private facturaExternaService: FacturaExternaTmpService,  private alertService:AlertService,
              private _t: TranslateService, private _fets: FirmaElectronicaTokenService, private _dfes: TramiteFirmasElectronicasService,
              private sessionStorage: SessionStorageService, private _lps:LoadingPanelService) {
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.escribaTokenEnviadoBtnSubmitLabel = this.translations.button1;
    });
    this.getIpAddress();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      aceptar: this._t.get('form.button.aceptar'),
      titleWarnMsg: this._t.get('form.msg.warn-summary'),
      messageWarnMsg: this._t.get('components.app-procesar-tramite.message-warn-factura'),
      button1: this._t.get('components.app-escriba-token-enviado.button1'),
    }));
  }


  //#region EnviarTokenFirmaElectronicaComponent
  showEnviarTokenFirmaElectronica(tramRegistroSolicitudId: number) {
    this.#tramRegistroSolicitudId = tramRegistroSolicitudId;
    this._enviarTokenFirmaElectronica.showDialog();
  }

  onEnviarTokenFirmaElectronica(option: 'sms' | 'correo') {
    this._enviarTokenFirmaElectronica.hideDialog();
    this._lps.show();
    if(option === 'sms') {
      this.porMensajeTexto();
    }else{
      this.porCorreo();
    }
  }

  porMensajeTexto() {
    this._fets.enviarTokenCorreoFirmaElectronica(this.#tramRegistroSolicitudId, "sms").subscribe({
      next: (response:boolean) => {
        this._tokenEnviado.showDialog();
      },complete: () => {
        this._lps.hide();
      }
    });
  }

  porCorreo() {
    this._fets.enviarTokenCorreoFirmaElectronica(this.#tramRegistroSolicitudId, "correo").subscribe({
      next: (response:boolean) => {
        this._tokenEnviado.showDialog();
      },error: (error) => {
        this._lps.hide();
      }
      ,complete: () => {
        this._lps.hide();
      }
    });
  }
  //#endregion

  //#region EscribaTokenEnviadoComponent
  onReenviarToken($event: void) {
    this._escribaTokenEnviado.hideDialog();
    this._enviarTokenFirmaElectronica.showDialog();
  }

  onSubmitToken($event: void) {
    const request = {
      token: this._escribaTokenEnviado.form.get('token')?.value,
      tramRegistroSolicitudId: this.#tramRegistroSolicitudId,
      infoDispositivo: {
        navegador: navigator.userAgent,
        ip: this.#ipAddress
      } as InfoDispositivo
    } as RequestFirmarDeclaracion;

    this.firmarTramite(request);
  }

  firmarTramite(request: RequestFirmarDeclaracion) {
    this._escribaTokenEnviado.hideDialog();
    this._lps.show();
    this._dfes.firmarTramite(request).subscribe({
      next: (response: TramiteFirmadoId) => {
        this.validateNextStep().then();
        this._escribaTokenEnviado.hideDialog();
      }, error: (error) => {
        this._lps.hide();
        this._escribaTokenEnviado.showDialog();
      }, complete: () => {
      }
    });
  }

  private async validateNextStep() {
    if (!this.requierePago) {
      this.tramiteFirmado.showDialog(this.#tramRegistroSolicitudId);
      return;
    }
    switch (this.fuentePago) {
      case ImpuestosFuente.TRAMITES:
        this.redirectToConsultaPagos(this.#tramRegistroSolicitudId);
        break;
      case ImpuestosFuente.TRIBUTOS:
        await this.generaFacturacionElectronica();
        break;
    }
  }

  async generaFacturacionElectronica() {
    const body = {
      solicitud: this.#tramRegistroSolicitudId
    }
    this._lps.show();
    this._sitiGobService.createRecibo(body).subscribe({
      next: (lote: number) => {
        this.lote = lote;
        this.tramiteFirmado.showDialog(this.#tramRegistroSolicitudId);
        this._lps.hide();
      }, error: error => {
        this._lps.hide();
        this.getMessageWarn(this.translations.messageWarnMsg, this.translations.titleWarnMsg)
          .subscribe(value => {
            this.redirectToMisTramites();
          })
      }
    });
  }

  getIpAddress() {
    this._dfes.getIPAddress().subscribe(
      {
        next: (data: any) => this.#ipAddress = data.ip
      }
    );
  }
  //#endregion

  //#region TokenEnviadoComponent

  onContinuar($event: void) {
    this._tokenEnviado.hideDialog();
    this._escribaTokenEnviado.showDialog();
  }

  //#endregion


  async getFacturaDetalleFacturaExtTmp(solicitud: number): Promise<IFacturaExternaTmp> {
    return await firstValueFrom(this.facturaExternaService.getDetalleBySolicitud(solicitud)).then();
  }


  redirectToConsultaPagos(tramRegistroSolicitudId: number) {
    this.router.navigate(['/tramites/consulta-pagos'],
      { state: { data: tramRegistroSolicitudId } })
  }

  async redireccionPagosExternos(tramRegistroSolicitudId: number) {
    try {
      this._lps.show();
      if (!(await firstValueFrom(this.facturaExternaService.isVigente(tramRegistroSolicitudId)).then())
        && this.lote == undefined) {
        await firstValueFrom(this.creaFacturacionElectronica(tramRegistroSolicitudId)).then();
      }
      const detalleFactura = await this.getFacturaDetalleFacturaExtTmp(tramRegistroSolicitudId);

      this.sessionStorage.setItem(this.sessionStorage.DETALLE_SOLICITUD,
        {solicitud: tramRegistroSolicitudId, lote: detalleFactura.loteFactura} as IDataSolicitud);
      //se agregan datos para ambiente de pruebas

      const token = await this.generaToken(detalleFactura.referencia, tramRegistroSolicitudId);
      const url = `${environment.portalUrl}${ConstantPortal.pagoPSE}/${token}`;
      window.location.href = url;
      this._lps.hide();
    }catch (err) {
      this._lps.hide();
      this.getMessageWarn(this.translations.messageWarnMsg, this.translations.titleWarnMsg).subscribe(value => {
        this.redirectToMisTramites();
      });
      console.error(err);
    }

  }

  async generaToken(referencia: string, solicitud:number): Promise<string> {
    const body: ICrearPseUrlFacturacion = {referencia: referencia, solicitud: solicitud };
    return await firstValueFrom(this._sitiGobService.crearUrl(body)).then();
  }

  redirectToDetalleRadicado(tramRegistroSolicitudId: number) {
    this.router.navigate(['/tramites/detalle-radicado'],
      { state: { data: tramRegistroSolicitudId } })
  }

  redirectToMisTramites() {
    this.router.navigate(['/tramites/estado-tramite'])
  }

  creaFacturacionElectronica(solicitud: number): Observable<number> {
    return this._sitiGobService.createRecibo({solicitud});
  }

  getMessageWarn(message: string, title: string): Observable<any> {
    return this.alertService.show({
      data: {
        icon: AlertIcon.WARN,
        showIcon: false,
        title: "",
        html: `
            <div>
                <h1 class="text-orange-500 font-24">¡${title}!</h1>
                <div>
                    <p class="font-16 text-black"> ${message} </p>
                </div>
            </div> `,
        showAccept: true,
        acceptButton: {
          label: this.translations.aceptar,
          class: 'border-rounded-xl  hover:bg-cyan-500 w-13rem',
        }
      }
    });
  }
}
